import React from 'react';
import styles from 'Nori/Container/ContainerXL.module.scss';

const ContainerXL = ({ className = '', children, ...props }) => (
  <div
    className={`${styles.containerXL} ${className} `}
    {...props}
    data-qa-tag="container-xl"
  >
    {children}
  </div>
);

export default ContainerXL;
